import { NgModule } from '@angular/core';

import { InfiniteScrollService } from './infinite.scroll.service';
import { InfiniteScrollDirective } from './infinite.scroll.directive';
import { WindowRefService } from './../../service/window/window.service';

@NgModule({
    declarations: [
        InfiniteScrollDirective
    ],
    imports: [],
    exports: [
        InfiniteScrollDirective
    ],
    providers: [
        WindowRefService,
        InfiniteScrollService
    ]
})
// tslint:disable-next-line:no-unnecessary-class
export class InfiniteScrollSharedDirectiveModule {}
